// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","loader__picture":"Loader_loader__picture__B5m74","rotation":"Loader_rotation__zW3DX","loader_notBackground":"Loader_loader_notBackground__XbqQT"};